const postalCodeExamplesByIsoCode: Record<string, string> = {
  af: '1001',
  ax: '22950',
  al: '1001',
  dz: '16000',
  as: '96799',
  ad: 'AD700',
  ai: 'AI-2640',
  ar: 'C1000AAB',
  am: '0010',
  au: '2000',
  at: '1010',
  az: 'AZ1000',
  bh: '1234',
  bd: '1212',
  bb: 'BB11111',
  by: '220030',
  be: '1000',
  bm: 'HM 12',
  bo: '01001',
  ba: '71000',
  br: '01000-000',
  bn: 'BA 1231',
  bg: '1000',
  kh: '12251',
  ca: 'K1A 0B1',
  ky: 'KY1-1102',
  cl: '8320000',
  cn: '100000',
  co: '110111',
  cr: '10101',
  hr: '10000',
  cu: '10400',
  cy: 'CY-1900',
  cz: '110 00',
  dk: '1000',
  do: '10110',
  ec: '090150',
  eg: '11511',
  sv: '01101',
  ee: '10111',
  et: '1000',
  fo: '100',
  fi: '00100',
  fr: '75001',
  ge: '0100',
  de: '10115',
  gh: '00000',
  gi: 'GX11 1AA',
  gr: '10100',
  gl: '3900',
  gu: '96910',
  gt: '01001',
  gg: 'GY1 1AA',
  gy: 'GY1000',
  ht: 'HT6110',
  va: '00120',
  hn: '11101',
  hk: '999077',
  hu: '1061',
  is: '101',
  in: '110001',
  id: '40115',
  ir: '1234567890',
  iq: '10001',
  ie: 'D02 X285',
  im: 'IM1 1AA',
  il: '91000',
  it: '00118',
  jp: '100-0001',
  je: 'JE2 3AA',
  jo: '11118',
  kz: '050000',
  ke: '00100',
  kr: '03071',
  kw: '13001',
  kg: '720001',
  la: '01000',
  lv: 'LV-1001',
  lb: '0000',
  li: '9490',
  lt: 'LT-01100',
  lu: 'L-1234',
  mk: '1000',
  my: '50000',
  mt: 'MTK 1000',
  mh: '96960',
  mu: '742CU',
  mx: '01000',
  fm: '96941',
  md: 'MD-2001',
  mc: '98000',
  mn: '211238',
  me: '81000',
  ma: '40000',
  np: '44600',
  nl: '1012 AB',
  nc: '98800',
  nz: '6011',
  ni: '50501',
  ng: '100001',
  mp: '96950',
  no: '0150',
  om: '111',
  pk: '44000',
  pw: '96940',
  pa: '0801',
  pg: '121',
  py: '1000',
  pe: '01101',
  ph: '1000',
  pn: 'PCRN 1ZZ',
  pl: '00-001',
  pt: '1000-123',
  pr: '00901',
  ro: '010031',
  ru: '101000',
  sm: '47890',
  sa: '11323',
  rs: '11000',
  sg: '018989',
  sk: '010 01',
  si: '1000',
  za: '0001',
  es: '28001',
  lk: '00100',
  se: '111 22',
  ch: '8001',
  tw: '100',
  tj: '734001',
  tz: '11101',
  th: '10110',
  tt: 'TT1234',
  tn: '1000',
  tr: '34010',
  tm: '744000',
  ug: '256001',
  ua: '01001',
  uk: 'SW1A 1AA',
  us: '90210',
  uy: '11300',
  uz: '100000',
  ve: '1010',
  vn: '100000',
  vi: '00802',
}

export function getPostalCodeExample(isoCode?: string) {
  const normalizedIsoCode = isoCode?.trim().toLowerCase()
  if (normalizedIsoCode && postalCodeExamplesByIsoCode[normalizedIsoCode]) {
    return postalCodeExamplesByIsoCode[normalizedIsoCode]
  }

  return ''
}
